import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PrinterpreferenceService {

  constructor() { }
  setPrinterPreference(printer:string){
    localStorage.setItem("SelectedPrinter",printer);
  }
  getPrinterPreference(){
    return localStorage.getItem("SelectedPrinter");
  }
}
